// extracted by mini-css-extract-plugin
export default {"root":"ToggleGroup_root__uQqOA","label":"ToggleGroup_label__udNil","track":"ToggleGroup_track__5yRIc","segment":"ToggleGroup_segment__hd3zS","active":"ToggleGroup_active__iTjUp"};